export enum ChatParty {
    agent = 'agent',
    client = 'client',
}
